import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibBriefShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import {
  InlineOverlay,
  InlineOverlayHeader,
  InlineOverlayFooter,
  InlineOverlayBody,
  InlineOverlayCloseButton
} from '@bibliocommons/base-inline-overlay';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { Checkmark } from '@bibliocommons/deprecated-base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';

import BibBrief from 'app/components/shared/BibBrief';
import MessagingContainer from 'app/components/Messaging/MessagingContainer';
import DigitalFormats from '../../digital-formats';

export class DigitalCheckoutWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      duration: null,
      format: null
    };
    bindAll(this);
  }

  handleFormatSelect(format) {
    this.setState({ format });
  }

  handleDurationSelect(duration) {
    this.setState({ duration });
  }

  handleCheckout(e) {
    if (e) {
      e.preventDefault();
    }

    const { format, duration } = this.state;
    const { accountId, bib, holdId, messagingId, workflowId, reciprocalRank } = this.props;
    this.props.digitalCheckout({
      accountId,
      messagingId,
      metadataId: bib.get('id'),
      workflowId,
      title: bib.get('title'),
      format,
      duration,
      holdId,
      reciprocalRank
    });
  }

  renderQuickstartLink() {
    const { showQuickStartLink, quickStartUrl } = this.props;

    if (showQuickStartLink) {
      return <FormattedHTMLMessage id="digital_download_quickstart_link" values={{ quickStartUrl }} />;
    }

    return null;
  }

  render() {
    const { handleClose, bib, isLoading, formats, provider, requireFormats = false } = this.props;
    return (
      <InlineOverlay handleClose={handleClose}>
        <form action="/" onSubmit={this.handleCheckout} method="post">
          <InlineOverlayHeader>
            <FormattedMessage id="check_out_now" />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            <MessagingContainer id={bib.get('id')}>
              {messageOptions => <GenericForm {...messageOptions} />}
            </MessagingContainer>
            <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />
            <DigitalFormats
              formats={formats}
              provider={provider}
              selectable={requireFormats}
              isAvailable
              metadataId={bib.get('id')}
              onSelectFormat={this.handleFormatSelect}
              handleDurationSelect={this.handleDurationSelect}
              fetchDigitalFormats={this.props.fetchDigitalFormats}
            />
            {this.renderQuickstartLink()}
          </InlineOverlayBody>
          <InlineOverlayFooter>
            <PrimaryButton className="pull-right" isLoading={isLoading} type="submit">
              <Checkmark color="#FFF" /> <FormattedMessage id="check_out_now" />
            </PrimaryButton>
            <InlineOverlayCloseButton className="btn btn-link pull-right">
              <FormattedMessage id="button_nevermind_close" />
            </InlineOverlayCloseButton>
          </InlineOverlayFooter>
        </form>
      </InlineOverlay>
    );
  }
}

DigitalCheckoutWorkflowView.propTypes = {
  workflowId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  bib: bibBriefShape.isRequired,
  isLoading: PropTypes.bool,
  formats: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      name: PropTypes.string,
      hasDownloadLink: PropTypes.bool
    })
  ),
  provider: PropTypes.string.isRequired,
  requireFormats: PropTypes.bool,
  digitalCheckout: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  fetchDigitalFormats: PropTypes.func.isRequired,
  holdId: PropTypes.string,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  borrowingActions: PropTypes.objectOf(PropTypes.func),
  reciprocalRank: PropTypes.number,
  messagingId: PropTypes.string,
  showQuickStartLink: PropTypes.bool,
  quickStartUrl: PropTypes.string
};

DigitalCheckoutWorkflowView.displayName = 'DigitalCheckoutWorkflowView';

export default DigitalCheckoutWorkflowView;
